
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/PartnerWithUs/MI",
      function () {
        return require("private-next-pages/PartnerWithUs/MI.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/PartnerWithUs/MI"])
      });
    }
  